import { render } from "./MessageIn.vue?vue&type=template&id=09cd8842"
import script from "./MessageIn.vue?vue&type=script&lang=ts"
export * from "./MessageIn.vue?vue&type=script&lang=ts"
script.render = render

export default script